import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">实时动态</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-foreground-600 text-sm">黑料网站的最新公告、更新日志与运营动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>
          <div className="space-y-5">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-[7px] md:left-[13px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded-full">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 leading-relaxed">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}